/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import AnalyticsUtil from '../../../../utils/AnalyticsUtil';
import strings from '../../../../translations/en.json';

export default class FeedBackAnalytics {
	ingest: ingestObject;
	analyticsUtils: AnalyticsUtil;
	static answer1: string;

	constructor() {
		this.analyticsUtils = new AnalyticsUtil();
		this.ingest = this.analyticsUtils.ingest;
	}

	/**
	 * [sendToIngest Post to ingest]
	 * @returns {[none]}
	 */
	sendToIngest() {
		this.analyticsUtils.checkOptin(this.ingest);
	}

	/**
	 * [initAnalytics Init Ingest]
	 * @returns {[none]}
	 */
	initAnalytics() {
		this.ingest.initializeDefaultData();
	}

	/**
	 * [logAnalytics A utility method to set multiple values at once]
	 * @param  {[object of key/value pairs]} dataObject [events]
	 * @returns {[none]}
	 */
	logAnalytics(dataObject: Object) {
		if (window.cchome.util.hasFeature('Inline_Feedback')) {
			this.ingest.setDataValue('event', 'workflow', 'Home');
			this.analyticsUtils.logAnalytics(dataObject);
			this.sendToIngest();
		}
	}

	/**
	 * Post event when the tour buttons are clicked
	 */
	postFeedBackButtonClick(answer: string, questionNumber: string) {
		this.initAnalytics();

		let contentName = '';
		if (questionNumber === '1') {
			contentName = strings['app.feedbackSurvey.title1'];
			FeedBackAnalytics.answer1 = answer;
		}
		else {
			contentName = strings['app.feedbackSurvey.title2'];
		}

		const data: dataObject = {
			setEventSubcategory: 'Feedback',
			setEventType: 'click',
			setEventSubtype: 'question',
			setEventValue: answer,
			setUISortOrder: questionNumber,
			setContentName: contentName,
		};

		if (questionNumber === '2') {
			data.setEventContextGUID = FeedBackAnalytics.answer1;
		}

		this.logAnalytics(data);
	}

	/**
	 * Post render event
	 */
	postFeedBackRender(questionNumber: string) {
		this.initAnalytics();

		let contentName = '';
		if (questionNumber === '1') {
			contentName = strings['app.feedbackSurvey.title1'];
		}
		else {
			contentName = strings['app.feedbackSurvey.title2'];
		}

		const data = {
			setEventSubcategory: 'Feedback',
			setEventType: 'render',
			setEventSubtype: 'question',
			setUISortOrder: questionNumber,
			setContentName: contentName,
		};

		this.logAnalytics(data);
	}
}

FeedBackAnalytics.answer1 = '';
